<template>
    <form :id="id ? id : this.uniqueid">
        <div class="d-flex">
            <h5 class="card-title">{{title}}</h5>
            <div class="ml-auto">
                <slot name="toolbar" :submit="submit" :working="working"></slot>
            </div>
        </div>
        <div class="row align-items-end">
            <button hidden type="submit" :id="id ? (id+'-submit') : (this.uniqueid+'-submit')"></button>
            <slot :control="control" name="body" :working="working"></slot>
        </div> 
        <div class="ml-auto">
            <slot name="footbar" :submit="submit" :working="working"></slot>
        </div>
        <div>
            <slot :data="data" name="footer"></slot>
            <infinite-loading v-if="paginate == 'true' && run == true"  @infinite="infiniteHandler" ref="infiniteLoading">
                <span slot="no-more">No hay más datos</span>
                <span slot="spinner">Cargando...</span>
                <span slot="no-results">No hay más datos</span>
            </infinite-loading>
        </div>
    </form>          
</template>

<script>
import Axios from 'axios';

export default {
    props: [
        'title',
        'id',
        'post',
        'get',
        'paginate',
    ],
    data() { return {
        data: [],
        control: {},
        page: 1,
        params: {},
        uniqueid: (new Date()).getTime()+'-form',
        run: false,
        url: '',
        working: false,
    }},
    mounted() {
        const vm = this;
        const form = $('#'+(this.id ? this.id : this.uniqueid));
        const buttonSubmit = $('#'+(this.id ? (this.id+'-submit') : (this.uniqueid+'-submit')));
       
        if(vm.get !== undefined) {
            vm.url = vm.get;
            if(vm.paginate == 'true') {
                vm.run = true;
                vm.refresh();
            } else {
                vm.getM();
            }
        } 

        form.submit(function(event) {
            event.preventDefault();
            
            vm.working = true;

            if(vm.post != undefined) {
                const data = form.serialize();
                vm.postM(data)
                .then(result=>{
                    vm.$parent.$emit('refresh');
                })
                .catch(e => console.log(e));
            } else {
                const data = form.serializeArray();
                vm.params = {};
                data.forEach(item => {
                    vm.params[item.name] = item.value;
                });
                if(vm.paginate == 'true') {
                    vm.run = true;
                    vm.refresh();
                } else {
                    vm.getM();
                }
            }
        });

        this.$on('submitEvent', function(url) {
            vm.url = url;
            buttonSubmit.click();
        });

        this.$parent.$on('externalFormReady', function() {
            vm.$emit('broadcastFormReady');
        });

        /* update.on('click', function() {
            event.preventDefault();

            if(vm.post !== undefined) {
                const data = form.serialize();
                vm.postM(data);
            }
        }); */

        this.$on('emitRefreshSelection', function(who, val){
            this.$emit('broadcastRefreshSelection', who, val);
        });
    },
    methods: {
        postM(data) {
            return new Promise((resolve,reject)=>{
                setTimeout(() => {
                axios.post(this.post, data).then(response => {
                    toastr["success"](response.data.message, "Éxito");
                    if(this.exit == true) {
                        $('#'+this.id).modal('hide');
                    }
                    this.working = false;
                    return resolve(response)
                }).catch(e => {
                    toastr["error"]('Ocurrió un problema inesperado', e);
                    this.working = false;
                    return reject(e)
                });
            }, 1000);
            })
        },
        getM(url) {
            return new Promise(resolve => {               
                setTimeout(() => {
                    axios.get(this.url, {params: {...this.params, ...{page: this.page}}}).then(res => {
                        if(this.paginate == 'true') {
                            this.data = this.data.concat(res.data.data);
                            this.page++;
                            if(this.page <= res.data.last_page) {
                                resolve(true);
                            } else {
                                resolve(false);
                            }  
                        } else {
                            this.data = res.data;
                        }
                        this.working = false;
                        this.$emit('broadcastFormReady');
                    }).catch(e => {
                        console.log('Error:', e);
                        this.working = false;
                    });
                }, 1000);
            });
        },
        infiniteHandler: async function($state) {
            await this.getM().then(again => {
                if(again) {
                    $state.loaded();
                } else {
                    $state.complete();
                }
            });
        }, 
        refresh: function() {
            if(this.$refs.infiniteLoading) {
                this.data = [];
                this.page = 1;
                this.$refs.infiniteLoading.stateChanger.reset(); 
            }
        },
        submit(url) {
            this.$emit('submitEvent', url);
        }
    }
}
</script>